import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/documents/document_view.png")